export const enFR = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB",
  url: "https://fr.lassie.co",
  logo: "https://fr.lassie.co/images/logo-with-name.svg",
  description:
    "France's most innovative pet insurance with transparent prices, fast claims processing and preventive care. The first true preventive pet insurance in France.",
  email: "contact@lassie.fr",
  address: {
    "@type": "PostalAddress",
    streetAddress: "9 rue des Colonnes",
    postalCode: "75002",
    addressLocality: "Paris",
    addressCountry: "FR",
  },
  sameAs: [
    "https://www.facebook.com/people/Lassie-France/61558443117226/",
    "https://www.instagram.com/lassie_fr/",
    "https://www.linkedin.com/company/lassieco/",
    "https://www.youtube.com/@lassie_co",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Insurance",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Dog Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Bronze",
              description: "Basic protection for veterinary care with coverage for illness and accident up to €1,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Silver",
              description: "All the essentials at a reasonable price with coverage for illness and accident up to €2,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Gold",
              description: "Covers significant health expenses with coverage for illness and accident up to €5,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Cat Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Bronze",
              description: "Basic protection for veterinary care with coverage for illness and accident up to €1,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Silver",
              description: "All the essentials at a reasonable price with coverage for illness and accident up to €2,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Gold",
              description: "Covers significant health expenses with coverage for illness and accident up to €5,000.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://fr.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
